module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clientForm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 d-flex flex-column mb-3"
  }, [_c('label', [_vm._v("Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.name),
      expression: "customer.name"
    }],
    staticClass: "fs-bigger bg-lighter bold",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.customer.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "name", $event.target.value)
      }, _vm.emitChange]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex flex-column mt-1 mb-3"
  }, [_c('label', [_vm._v("Country:")]), _vm._v(" "), _c('country-picker', {
    attrs: {
      "topCodes": _vm.topCountries,
      "openDirection": "bottom",
      "selectedCountryValue": _vm.selectedCountry,
      "disabled": false,
      "allowEmpty": false,
      "customClass": 'mb-2',
      "error": !_vm.selectedCountry
    },
    on: {
      "input": function($event) {
        return _vm.updateCountry($event, 'country')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex flex-column mt-1"
  }, [_c('label', [_vm._v("Phone:")]), _vm._v(" "), _c('PhoneInput', {
    ref: "phoneInput",
    attrs: {
      "country": _vm.phoneCountry
    },
    on: {
      "input": _vm.onPhoneInput,
      "validate": _vm.isPhoneValid,
      "country-changed": _vm.onFlagChanged
    },
    model: {
      value: (_vm.customer.phone),
      callback: function($$v) {
        _vm.$set(_vm.customer, "phone", $$v)
      },
      expression: "customer.phone"
    }
  }), _vm._v(" "), (_vm.customer.phone && !_vm.customerPhoneValid) ? _c('div', {
    staticClass: "error"
  }, [_c('span', [_vm._v("Phone Number Invalid.")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex flex-column mt-1 mb-3"
  }, [_c('label', [_vm._v("Hotel:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.accomodation),
      expression: "customer.accomodation"
    }],
    staticClass: "fs-bigger bg-lighter",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.customer.accomodation)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "accomodation", $event.target.value)
      }, _vm.emitChange]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex flex-column mt-1 mb-3"
  }, [_c('label', [_vm._v("Room:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.room),
      expression: "customer.room"
    }],
    staticClass: "fs-bigger bg-lighter",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.customer.room)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "room", $event.target.value)
      }, _vm.emitChange]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 d-flex flex-column mt-1 mb-3"
  }, [_c('label', {
    class: {
      'color-6': !_vm.$v.customer.email.email
    }
  }, [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.email),
      expression: "customer.email"
    }],
    staticClass: "fs-bigger bg-lighter",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.customer.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "email", $event.target.value)
      }, _vm.emitChange]
    }
  }), _vm._v(" "), (!_vm.$v.customer.email.email) ? _c('span', {
    staticClass: "color-6 fs-smaller"
  }, [(!_vm.$v.customer.email.email) ? _c('span', [_vm._v("Invalid email")]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-46daf211", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46daf211"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabCustomer/ClientForm.vue
// module id = 1931
// module chunks = 0